import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    style={{ overflow: 'visible', ...props.style }}
    {...props}
  >
    <path
      d="M7.5 14V5.87402L4.35352 9.02051C4.15829 9.21555 3.84171 9.21555 3.64648 9.02051C3.45128 8.8253 3.45139 8.50875 3.64648 8.31348L7.64648 4.31348L7.72266 4.25098C7.80422 4.19656 7.9005 4.16699 8 4.16699C8.13261 4.16699 8.25975 4.21971 8.35352 4.31348L12.3535 8.31348L12.418 8.3916C12.546 8.58566 12.5243 8.84971 12.3535 9.02051C12.1826 9.19131 11.9187 9.21233 11.7246 9.08398L11.6465 9.02051L8.5 5.87402V14C8.5 14.2761 8.27614 14.5 8 14.5C7.72386 14.5 7.5 14.2761 7.5 14ZM14 1.5C14.2761 1.5 14.5 1.72386 14.5 2C14.5 2.27614 14.2761 2.5 14 2.5H2C1.72386 2.5 1.5 2.27614 1.5 2C1.5 1.72386 1.72386 1.5 2 1.5H14Z"
      fill="currentColor"
      fillOpacity="0.702"
    />
  </svg>
);

export { SvgComponent as UploadIcon };

